import React, { FC, useMemo, useState } from 'react';
import { AdminTable } from '../components/table/AdminTable';
import { ApiPath } from '../api/ApiPath';
import { AdminTableActionsItem } from '../components/table/interfaces/AdminTableActionsItem';
import { AdminToolbar } from '../components/toolbar/AdminToolbar';
import { AdminToolbarTitle } from '../components/toolbar/AdminToolbarTitle';
import { Site } from './dto/Site';
import { AdminToolbarActions } from '../components/toolbar/AdminToolbarActions';
import { AdminToolbarButton } from '../components/toolbar/AdminToolbarButton';
import { SitesCreate } from './SitesCreate';
import { Modal } from 'react-bootstrap';
import { SitesEdit } from './SitesEdit';
import { api } from '../functions/api';
import { useDeleteItem } from '../hooks/useDeleteItem';
import { useSiteColumns } from './hooks/useSiteColumns';
import { useSites } from '../hooks/useSites';
import { useTranslation } from 'react-i18next';

export const Sites: FC = () => {
  const { t } = useTranslation();
  const [editableSite, setEditableSite] = useState<Site | null>(null);
  const deleteSite = useDeleteItem<Site>((item) =>
    api({
      url: ApiPath.Site.replace(':id', item.id),
      method: 'delete',
    }),
  );
  const { data = [], isLoading, reload } = useSites();
  const actions = useMemo<AdminTableActionsItem<Site>[]>(
    () => [
      {
        title: t('Edit').toString(),
        onClick: setEditableSite,
      },
      {
        title: t('Delete').toString(),
        onClick: (item) => {
          if (window.confirm(`Are you sure you want to delete?`)) {
            deleteSite(item).then(() => reload());
          }
        },
      },
    ],
    [deleteSite, reload, t],
  );
  const columns = useSiteColumns();
  const [adding, setAdding] = useState(false);

  return (
    <>
      <AdminToolbar>
        <AdminToolbarTitle>{t('Sites')}</AdminToolbarTitle>

        <AdminToolbarActions>
          <AdminToolbarButton onClick={() => setAdding(true)}>{t('Add site')}</AdminToolbarButton>
        </AdminToolbarActions>
      </AdminToolbar>

      <AdminTable items={data} loading={isLoading} columns={columns} actions={actions} />

      <Modal show={adding} onHide={() => setAdding(false)}>
        <SitesCreate update={reload} />
      </Modal>

      <Modal show={!!editableSite} onHide={() => setEditableSite(null)}>
        {editableSite ? <SitesEdit update={reload} site={editableSite} /> : null}
      </Modal>
    </>
  );
};
